import { Pipe, PipeTransform } from '@angular/core';
// import { MasterDataService } from '@service/master-data.service';
import { TranslatePipe } from './translate.pipe';
import { TitleCasePipe } from '@angular/common';
import { UserService } from '../services/user.service';
@Pipe({
  name: 'healthpack',
  pure: false 
})
export class HealthpackPipe implements PipeTransform {

private inFilter(filterValue, options) {
    let filterOptions = [].concat.apply([], options.map(o=>o.filter || []))
    return filterOptions.includes(filterValue)
  }

  private ninFilter(filterValue, options) {
    let filterOptions = [].concat.apply([], options.map(o => o.filter || []))
    return !filterOptions.includes(filterValue)
  }
  private compareFilter(filterValue, options) {
    let filterOptions = [].concat.apply([], options.map(o => o.filter || []))
    const intersection = filterOptions.filter(element => filterValue.includes(element));
    return intersection.length > 0
  }
  private rangeFilter(arr1 = [], arr2 = []) {
    const [el11, el12] = arr1;
    const [el21, el22] = arr2;
    const leftLimit = Math.max(el11, el21);
    const rightLimit = Math.min(el12, el22);
    return leftLimit < rightLimit;
  };

  transform(packs: any, applicableFilter: any, isModal: boolean = false, timestamp: any = 1): any {
    if (!packs) return [];
    if (isModal) {
      if (!applicableFilter) return packs;
      let selectedFilters:Array<any> = applicableFilter.map(filterValues => {
        return {
          selection: filterValues.selection,
          attribute: filterValues.attribute,
          options: filterValues.options?.filter(opt => opt.selected) || []
        }
      }).filter(f=> f.options?.length > 0)
      const filteredPacks = packs.filter(p => {
        return selectedFilters.every(f => {
          if (f.selection == 'child') {
            const opt = f.options[0];
            f.selection = opt.selection;
          }
          let attributeValue = null;
          if (!['range'].includes(f.selection))
            attributeValue = p['_filterValues'][f.attribute]
          switch (f.selection) {
            case 'in':
              return this.inFilter(attributeValue, f.options)
            case 'nin':
              return this.ninFilter(attributeValue, f.options)
            case 'compare':
              return this.compareFilter(attributeValue, f.options)
            case 'range':
              let minAttribute = p['_filterValues'][f.attribute.minAttribute]
              let maxAttribute = p['_filterValues'][f.attribute.maxAttribute]
              const rangesArray = f.options.map(opt => {
                return [opt.range.min, opt.range.max]
              })
              const ranges = [].concat.apply([], rangesArray)
              let minRange = Math.min(...ranges)
              let maxRange = Math.max(...ranges)
              return this.rangeFilter([minAttribute, maxAttribute], [minRange, maxRange])
            default:
              return true
          }
        })
      })
      // console.log('filteredPacks', filteredPacks)
      return filteredPacks
    } else {
      let selectedFitlers = applicableFilter.reduce((filter, selected) => {
        filter[selected['type']] = selected.options.filter(opt => opt.selected);
        return filter;
      }, {})
      let filteredPacks = packs.filter(concept => {
        if (!concept.filters) return true;
        let canAgeFilter = (concept.filters.hasOwnProperty('minAge') && concept.filters.hasOwnProperty('maxAge'))
        let gender = true, age = true;
        if (concept.filters.hasOwnProperty('gender') && selectedFitlers.gender && selectedFitlers.gender.length > 0) {
          gender = concept.filters.gender == 'A' || selectedFitlers.gender.find(g => g.key == concept.filters.gender)
        }
        if (canAgeFilter && selectedFitlers.age && selectedFitlers.age.length > 0) {
          age = selectedFitlers.age.find(a => concept.filters.minAge <= a.range.max && concept.filters.maxAge >= a.range.min)
        }
        return gender && age
      })
      return filteredPacks;
    }
  }

  // constructor(private translate: TranslatePipe, private titleCasePipe: TitleCasePipe, private user: UserService){}

  // transform(packs: any, applicableFilter: any,isModal?): any {
  //   if(isModal){
  //     if(applicableFilter[2] && applicableFilter[2].options.length === 0) {
  //       let facList = this.user.getAttributeForListingType('facilities', true)['facilities'];
  //       console.log(facList,"--908908----", this.user.getAttributeForListingType('facilities', true));

  //     let facilityList = facList.map(a => ({'key': a.facilityId, 'label': this.titleCasePipe.transform(this.translate.transform(a.facilityName, 'LANGARRAY', 'name', null)), 'checked': false}))
  //     let val = applicableFilter[2].options.push(...facilityList)
  //     }
  //     let selectedFitlers = applicableFilter.reduce((filter, checked) => {
  //       filter[checked['type']] = checked.options.filter(opt => opt.checked);
  //       return filter;
  //     }, {})
  //     let filteredPacks = packs.filter(concept => {
  //       let facFilter = true, gender = true, age = true;
  //       if(concept.facilities && selectedFitlers && selectedFitlers.facility && selectedFitlers.facility.length > 0) {
  //         facFilter = concept.facilities.find(a => selectedFitlers.facility.some(b => b.key === a.facilityId))
  //         // return facFilter;
  //       }
  //       if (!concept.filters)
  //         return true;
  //       let canAgeFilter = (concept.filters.hasOwnProperty('minAge') && concept.filters.hasOwnProperty('maxAge'))
  //       if (concept.filters.hasOwnProperty('gender') && selectedFitlers.gender && selectedFitlers.gender.length > 0) {
  //         gender = concept.filters.gender == 'A' || selectedFitlers.gender.find(g => g.key == concept.filters.gender)
  //       }
  //       if (canAgeFilter && selectedFitlers.age && selectedFitlers.age.length > 0) {
  //         age = selectedFitlers.age.find(a => concept.filters.minAge <= a.range.max && concept.filters.maxAge >= a.range.min)
  //       }
  //       return gender && age && facFilter
  //     })
  //     return filteredPacks;
  //   }else{
  //     let selectedFitlers = applicableFilter.reduce((filter, checked) => {
  //       filter[checked['type']] = checked.options.filter(opt => opt.checked);
  //       return filter;
  //     }, {})
  //     let filteredPacks = packs.filter(concept => {
  //       if (!concept.filters) return true;
  //       let canAgeFilter = (concept.filters.hasOwnProperty('minAge') && concept.filters.hasOwnProperty('maxAge'))
  //       let gender = true, age = true;
  //       if (concept.filters.hasOwnProperty('gender') && selectedFitlers.gender && selectedFitlers.gender.length > 0) {
  //         gender = concept.filters.gender == 'A' || selectedFitlers.gender.find(g => g.key == concept.filters.gender)
  //       }
  //       if (canAgeFilter && selectedFitlers.age && selectedFitlers.age.length > 0) {
  //         age = selectedFitlers.age.find(a => concept.filters.minAge <= a.range.max && concept.filters.maxAge >= a.range.min)
  //       }
  //       return gender && age
  //     })
  //     return filteredPacks;
  //   }
  // }

}
